'use client';
import AppLogo from '@/components/common/AppLogo';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React from 'react';

// Rendered from the app-router error boundaries when a chunk-load
// failure has been confirmed (via a fresh probe of /api/version) to
// be caused by a new deploy replacing the old container's hashed JS
// chunks. The in-memory bundle still references filenames that no
// longer exist on origin, so soft navigation or Next.js `reset()`
// would just re-trigger the same failure.
//
// Distinct from the general `ErrorLayout` on purpose:
//   - No countdown-to-home. `useDelayedRouting('/')` would push a
//     route transition that tries to load chunks we know are gone.
//   - No `reset()` button. `reset()` re-renders the boundary's
//     subtree with the same stale bundle; the failure would repeat.
//   - No stack trace accordion / ProGlove display update. The user
//     hasn't hit a bug; they're just running a stale build.
//
// The only safe action is a hard browser reload, which fetches the
// current `index.html` and the new chunk graph. That is exactly —
// and only — what the button does.

export default function UpdateRequiredLayout(): React.JSX.Element {
  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <AppLogo my={3} />
        <Stack direction="column" alignItems="center" spacing={2} sx={{ width: '85%' }}>
          <Typography variant="h4" sx={{ textAlign: 'center' }}>
            New version required
          </Typography>
          <Typography variant="caption" sx={{ textAlign: 'center' }}>
            This page has been updated. Please reload to continue.
          </Typography>
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload
          </Button>
        </Stack>
      </Box>
    </Container>
  );
}
